// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FORGOT_EMAIL_PAGE_DATA } from '../../flows/login/pages/LoginHelp/constants';
import { useOldPhoneFormatter } from '../../helpers/usePhoneFormatter';

interface IProps {
  onValueChange: (value: string) => void;
}

export const PhoneInput = ({ onValueChange }: IProps) => {
  const { t } = useTranslation();
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [phoneInput, setPhoneInput] = useState<string>('');
  const { formattedPhoneValue } = useOldPhoneFormatter({ formatType: 'US', value: phoneInput });

  useEffect(() => {
    onValueChange(phoneInput);
  }, [phoneInput]);

  return (
    <form className='relative'>
      <input
        id='phoneInputField'
        type='phone'
        className='text-bw07 pt-[30px]  font-metricRSemibold text-[16px] tracking-widest border border-bw04 focus:outline-none rounded-md focus:border-action02 focus:shadow-sm hover:bg-bw01 w-full p-3 h-[60px]'
        maxLength={17}
        value={formattedPhoneValue}
        onChange={(event) => setPhoneInput(event.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
      <label
        className={`${isFocused || formattedPhoneValue ? 'text-[12px] text-action03 translate-y-[-140%]' : 'text-[16px] text-bw06 translate-y-[-50%]'} absolute top-[50%] transition duration-500 ease-in-out left-[16px] font-metricR`}
        htmlFor='phoneInputField'
      >
        {t(FORGOT_EMAIL_PAGE_DATA.INPUT_TITLE)}
      </label>
    </form>
  );
};
